import React, { useEffect } from "react";
import { Table } from "antd";

const DhvaniData = (props) => {
  const { ds, np, dr } = props.totals;
  const collum = [
    {
      title: "To Darshan",
      dataIndex: "toDarshan",
      key: "dr",
    },
    {
      title: "To Nikhil",
      dataIndex: "toNikhil",
      key: "np",
    },
  ];
  const data = [
    {
      toNikhil: (np - ds) * 10,
      toDarshan: (dr - ds) * 10,
    },
  ];
  return (
    <>
      <Table columns={collum} dataSource={data} pagination={false} />
    </>
  );
};

export default DhvaniData;
